/* Sidrex — sticky header controller.
   The Shopify section wrapper (.sdx-header-section) is the element that
   carries position: sticky and the state classes. The inner <header>
   keeps its own styling but lives inside a sticky container so that it
   remains pinned while the page scrolls beyond its own height.

   State classes on .sdx-header-section:
     sdx-header-section--sticky  → position: sticky; top: 0 (enabled via setting)
     is-scrolled                  → scroll past SCROLLED_AT (24px)
     is-hidden                    → scrolling down and past HIDE_AT (220px)

   Hide is suppressed while a mega menu panel or mobile drawer is open,
   in the theme editor (Shopify.designMode), and on reduced-motion. */
(function () {
  var header = document.querySelector('[data-sdx-header]');
  if (!header) return;

  // The Shopify section wrapper — the element we actually stick.
  var wrapper = header.closest('.shopify-section') || header.parentElement || header;
  if (!wrapper.classList.contains('sdx-header-section')) {
    // Legacy fallback: stick the header itself.
    wrapper = header;
  }

  // Move drawer + backdrop out of the (transformed) sticky container so their
  // position: fixed is anchored to the viewport, not the header wrapper. A
  // transformed ancestor makes fixed elements use it as their containing
  // block, which puts the drawer *behind* the page content on mobile.
  var drawerEl = header.querySelector('[data-sdx-drawer]');
  var backdropEl = header.querySelector('[data-sdx-drawer-backdrop]');
  if (drawerEl && drawerEl.parentElement !== document.body) {
    document.body.appendChild(drawerEl);
  }
  if (backdropEl && backdropEl.parentElement !== document.body) {
    document.body.appendChild(backdropEl);
  }

  // Respect the theme setting — the stickiness is opt-in via the section
  // editor. The sticky-by-default modifier originally lived on <header>.
  if (header.classList.contains('sdx-header--sticky')) {
    wrapper.classList.add('sdx-header-section--sticky');
  }

  var SCROLLED_AT = 24;
  var HIDE_AT = 220;
  var DIR_THRESHOLD = 4;
  var lastY = window.scrollY || 0;
  var ticking = false;

  var isEditor = !!(window.Shopify && window.Shopify.designMode);
  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { /* noop */ }

  function anyPanelOpen() {
    return !!header.querySelector('.sdx-header__nav-item.is-open')
        || !!document.querySelector('.sdx-header__drawer.is-open')
        || document.body.classList.contains('sdx-no-scroll');
  }

  function update() {
    ticking = false;
    var y = window.scrollY || 0;
    var delta = y - lastY;
    var dir = delta > 0 ? 'down' : (delta < 0 ? 'up' : null);

    if (y > SCROLLED_AT) wrapper.classList.add('is-scrolled');
    else wrapper.classList.remove('is-scrolled');

    var canHide = !isEditor && !reduceMotion && !anyPanelOpen();
    if (canHide && dir === 'down' && y > HIDE_AT && Math.abs(delta) > DIR_THRESHOLD) {
      wrapper.classList.add('is-hidden');
    } else if (dir === 'up' && Math.abs(delta) > DIR_THRESHOLD) {
      wrapper.classList.remove('is-hidden');
    }
    if (y <= SCROLLED_AT) wrapper.classList.remove('is-hidden');

    lastY = y;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  window.addEventListener('pageshow', function () { lastY = window.scrollY || 0; update(); });

  function forceShow() { wrapper.classList.remove('is-hidden'); }
  header.addEventListener('focusin', forceShow);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') forceShow(); });

  var drawer = drawerEl || document.querySelector('[data-sdx-drawer]');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function () {
      if (drawer.classList.contains('is-open')) forceShow();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  var navItems = header.querySelectorAll('[data-sdx-mega-item]');
  if (navItems.length && window.MutationObserver) {
    navItems.forEach(function (item) {
      new MutationObserver(function () {
        if (item.classList.contains('is-open')) forceShow();
      }).observe(item, { attributes: true, attributeFilter: ['class'] });
    });
  }

  update();
})();
